module.exports = __webpack_public_path__ + "img/debbie.19900a48.webp";